import { PIVOT_PATHS } from "@/components/layout/pivotRoutes.ts";
import { useSetAtom } from "jotai";
import { useLocation } from "wouter";
import { openThreadsPanelSignalAtom } from "./navSignals.ts";
import { useShortcut } from "./useShortcut.ts";

/**
 * The `nav.*` registry entries, mounted once at the app root inside the
 * router. Each one goes through `useShortcut` like any other shortcut, so a
 * user can move "go to threads" off its `g t` sequence and onto a chord.
 *
 * Destinations are read off the pivot table rather than spelled out, so a key
 * and the sidebar row it mirrors cannot come to mean different addresses.
 */
export const GoToNavigation = () => {
  const [, setLocation] = useLocation();
  const requestThreadsPanel = useSetAtom(openThreadsPanelSignalAtom);

  useShortcut("nav.calendar", () => setLocation(PIVOT_PATHS.calendar), { deps: [setLocation] });
  // Threads live in the sidebar beside the canvas, not at an address of their
  // own — land on home and open the panel rather than navigating to a page
  // that does not exist.
  useShortcut(
    "nav.threads",
    () => {
      setLocation(PIVOT_PATHS.newchat);
      requestThreadsPanel((n) => n + 1);
    },
    { deps: [setLocation, requestThreadsPanel] },
  );
  useShortcut("nav.routines", () => setLocation(PIVOT_PATHS.routines), { deps: [setLocation] });
  useShortcut("nav.skills", () => setLocation(PIVOT_PATHS.skills), { deps: [setLocation] });
  useShortcut("nav.memories", () => setLocation("/memories"), { deps: [setLocation] });
  useShortcut("nav.contacts", () => setLocation(PIVOT_PATHS.contacts), { deps: [setLocation] });
  useShortcut("nav.settings", () => setLocation("/settings"), { deps: [setLocation] });

  return null;
};
